import {observer} from 'mobx-react';
import React from 'react';
import {SidebarStore} from '../SidebarStore';
import {CollapsibleMenu} from '../CollapsibleMenu';
import {TreeComponent} from '../menu/TreeComponent';

@observer
export class SidebarAdministrator extends React.Component<{ store: SidebarStore }> {
  render() {
    const store = this.props.store;

    return (
      <div className="administrator-sidebar">
        <CollapsibleMenu label="System settings">
          <TreeComponent tree={store.systemSettingsMenu}/>
        </CollapsibleMenu>
        <CollapsibleMenu label="User Management">
          <TreeComponent tree={store.userManagementMenu}/>
        </CollapsibleMenu>
        <CollapsibleMenu label="Classroom Management">
          <TreeComponent tree={store.classroomManagementMenu}/>
        </CollapsibleMenu>
      </div>
    );
  }
}
